import { render } from "./BiomarHeader.vue?vue&type=template&id=45c2b58c&scoped=true"
const script = {}

import "./BiomarHeader.vue?vue&type=style&index=0&id=45c2b58c&scoped=true&lang=scss"

import exportComponent from "/home/florian/dev/biomar/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c2b58c"]])

export default __exports__